import { formatPrice } from '@/lib/utils';

type Props = {
  priceCents: string | number;
  promoPriceCents?: string | number | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

export function PriceBlock({ priceCents, promoPriceCents, size = 'md', className = '' }: Props) {
  const hasPromo =
    promoPriceCents != null &&
    promoPriceCents !== '' &&
    Number(promoPriceCents) < Number(priceCents);
  const current = hasPromo ? promoPriceCents! : priceCents;
  const savings = hasPromo ? Number(priceCents) - Number(promoPriceCents) : 0;

  const priceClass =
    size === 'lg'
      ? 'text-3xl font-semibold'
      : size === 'sm'
        ? 'text-base font-semibold'
        : 'text-lg font-semibold';

  return (
    <div className={className}>
      <div className="flex flex-wrap items-baseline gap-2">
        <span className={`${priceClass} text-fg`}>{formatPrice(current)}</span>
        {hasPromo && (
          <span className="text-sm text-muted line-through">{formatPrice(priceCents)}</span>
        )}
      </div>
      {savings > 0 && (
        <p className="mt-0.5 text-xs font-medium text-[var(--color-accent)]">
          Economia de {formatPrice(savings)}
        </p>
      )}
    </div>
  );
}
